import { render, staticRenderFns } from "./zhao-biao-cai-gou.vue?vue&type=template&id=3e355988&scoped=true&"
import script from "./zhao-biao-cai-gou.vue?vue&type=script&lang=js&"
export * from "./zhao-biao-cai-gou.vue?vue&type=script&lang=js&"
import style0 from "./zhao-biao-cai-gou.vue?vue&type=style&index=0&id=3e355988&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e355988",
  null
  
)

export default component.exports